"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var css = styled_components_1.default.span;
exports.default = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   height: 100%;\n   width: 100%;\n\n   ", "\n"], ["\n   height: 100%;\n   width: 100%;\n\n   ",
    "\n"])), function (props) {
    return props.hideIn &&
        props.hideIn + " {\n        .size-screen {\n            display: none;\n        }\n    }";
});
var templateObject_1;
//# sourceMappingURL=ScreenMedia.style.js.map